<template>
  <v-card outlined rounded="lg" ref="merchProductCard">
    <v-carousel
      :height="`${width}px`"
      hide-delimiters
      cycle
      :show-arrows-on-hover="merchProduct.images.length > 1"
      :show-arrows="merchProduct.images.length > 1"
    >
      <v-carousel-item
        v-for="(image, index) in merchProduct.images"
        :key="index"
      >
        <v-img :src="image || null" :aspect-ratio="1" contain class="white">
        </v-img>
      </v-carousel-item>
    </v-carousel>
    <div
      style="
        position: absolute;
        top: 8px;
        right: 8px;
        left: 8px;
        display: flex;
      "
    >
      <v-chip v-if="merchProduct.type === 'COMBO'" color="primary" small>
        <v-icon left small>mdi-package-variant-closed</v-icon>
        Combo
      </v-chip>
      <v-spacer />

      <v-btn small icon color="primary" @click="$emit('edit', merchProduct)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </div>
    <div class="pa-3 d-flex flex-column" style="min-height: 56px">
      <h6 class="text-subtitle-1 mb-0 lh-1 text-truncate">
        {{ merchProduct.name }}
      </h6>
      <p class="text--secondary mb-0 lh-1 text-truncate">
        {{ merchProduct.description }}
      </p>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MerchProductCard",
  props: {
    merchProduct: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      width: 0,
    };
  },
  methods: {
    updateWidth() {
      const element = this.$refs.merchProductCard?.$el;
      if (element) this.width = element.clientWidth;
    },
  },
  mounted() {
    this.updateWidth();
    window.addEventListener("resize", this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  },
};
</script>
